import React, { useEffect, useState } from "react";
import { Button, Form, InputGroup } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { useDispatch } from "react-redux";
import emailIcon from "../assets/images/email.svg";
import infoIcon from "../assets/images/infobtnblue.svg";
import SubmitLoading from "../component/common-component/Loaders/SubmitLoading";
import { AssignPrivateMachine } from "../services/ReduxTookit/Slice/MachineRedux";

const AssignPrivateMachineModal = ({
  show,
  onHide,
  machineid,
  machinename,
  onSuccess,
}) => {
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (show) {
      setEmail("");
      setError("");
      setLoading(false);
    }
  }, [show]);

  const validateEmail = (val) => {
    if (!val || !val.trim()) {
      return "Email is required";
    }
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!regex.test(val.trim())) {
      return "Please enter a valid email address";
    }
    return "";
  };

  const handleSubmit = async (e) => {
    if (e) e.preventDefault();
    const err = validateEmail(email);
    if (err) {
      setError(err);
      return;
    }
    setError("");
    setLoading(true);

    try {
      const payload = {
        machineid: parseInt(machineid),
        email: email.trim(),
      };
      const response = await dispatch(AssignPrivateMachine(payload));
      setLoading(false);
      if (response?.payload?.isValidate) {
        setEmail("");
        if (onSuccess) onSuccess();
        onHide();
      }
    } catch (err) {
      setLoading(false);
    }
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      aria-labelledby="assign-private-machine-modal"
      centered
      className="invite-subscriber"
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title id="assign-private-machine-modal">
          Share Machine {machinename ? `(${machinename})` : ""}
        </Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <div className="invite-subscriber-note">
            <p>
              Assign this private machine to another registered subscriber so
              they can access and use it in their workflows.
            </p>
            <p style={{ color: "red" }}>
              <b>Note:</b> Only registered subscribers can be assigned. Please
              ensure the subscriber is already registered in QuantumDataLytica before
              assigning.
            </p>
          </div>

          <div className="header-search-input searchplaceholder mt-3">
            <div className="invite-search position-relative">
              <div className={`${error ? "error-border-line" : ""}`}>
                <InputGroup className="w-100">
                  <InputGroup.Text id="email-addon">
                    <img
                      src={emailIcon}
                      alt="email"
                      style={{ width: "16px", height: "16px" }}
                    />
                  </InputGroup.Text>
                  <Form.Control
                    type="email"
                    placeholder="Enter subscriber's registered email"
                    aria-label="Email"
                    aria-describedby="email-addon"
                    value={email}
                    onChange={(e) => {
                      setEmail(e.target.value);
                      if (error) setError("");
                    }}
                    autoFocus
                  />
                </InputGroup>
              </div>
              {error && (
                <p className="error-line">
                  <span className="error-message-icon">
                    <img src={infoIcon} alt="infoIcon" title={error} />
                  </span>
                  <span className="ms-1 text-danger">{error}</span>
                </p>
              )}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="grey-btn w-auto"
            onClick={onHide}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="blue-btn w-auto"
            disabled={loading}
          >
            {loading ? <SubmitLoading /> : "Submit"}
          </button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default AssignPrivateMachineModal;
